import { groupBy, map, keys, uniq, sortWith, ascend, prop } from 'ramda'
import chunk from 'chunk'

import { genLabel, labelHeader } from './label_flash'
import { MAX_ITEMS } from '../constants'

const typeMapper = {
  new: {
    recipient: 'reg_deliver_to_recipeint',
    address: 'reg_deliver_to_address',
  },
  old: {
    recipient: 'deliver_to_recipient',
    address: 'deliver_to_address',
  },
}
export const groupData = ({
  rows,
  group,
  eventName,
  eventCode,
  type,
  max = MAX_ITEMS,
}) => {
  const shippingItems = rows.filter(row => row.reg_deliver_option !== 'self_pickup' && row.reg_status === 'paid')
  const byRegisteration = groupBy(row => row.registration_id)
  const registrations = byRegisteration(shippingItems)
  const groupItems = (items) => {
    const groupedItems = groupBy(item => `${item.shirt_type}_${item.shirt}`, items)
    const countedItems = map(g => g.length, groupedItems)
    const mappedItems = keys(countedItems).map(name => ({ name: `${groupedItems[name][0].shirt_type} ${groupedItems[name][0].shirt}`, shirtId: `${eventCode}_${groupedItems[name][0].shirt_type}_${groupedItems[name][0].shirt}`, amount: countedItems[name] }))
    return mappedItems
  }
  const sortItems = items => sortWith([ascend(prop('name'))])(items)
  const data = []
  Object.keys(registrations)
    .map(registrationId => registrations[registrationId])
    .forEach((registration) => {
      const packs = chunk(registration, max)
      packs.forEach((items, index) => {
        const first = items[0]
        const mappedItems = groupItems(items)
        data.push({
          app: 'race',
          referenceId: first.registration_id,
          recipient: first[typeMapper[type].recipient].replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
          address: first[typeMapper[type].address].replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
          data: {
            count: items.length,
            items: sortItems(mappedItems),
            phones: keys(groupBy(item => item.reg_deliver_to_telephone, items)),
            bibs: items.map(item => item.bib),
            eventName,
            registrationType: first.ticket_type,
            emails: items.map(item => item.email),
          },
          seq: index + 1,
          last: packs.length,
          group,
          remarks: '',
        })
      })
    })
  return data
}
export const createLabel = (label, labelQrcode) => `
<td class="main-cell">
  <div class="label">
    ${labelQrcode(label)}
    <div class="recipient">
      <div class="recipient-data">
        [${label.data.bibs.join(', ')}] ${label.recipient} (${uniq(label.data.phones).join(', ')})<br />
        ${label.address}
      </div>
    </div>
    <div class="items">
      <div class="items-data">
      ${label.data.eventName ? `${label.data.eventName} (${label.data.registrationType})<br />` : ''}
      ${label.data.items.map(d => `[ ${d.amount} ] ${d.name}`).join('<br />')}
      </div>
    </div>
    ${labelHeader}
  </div>
</td>`

export default {
  groupData,
  genLabel: genLabel(createLabel),
}



// WEBPACK FOOTER //
// ./src/helpers/race_flash.js